export default "__VITE_ASSET__BakYiq5N__"